import { sanitizeChatMessage } from '../../../utils/safeHtml';
import { chatAttachmentUrl } from '../../../utils/chatAttachment';
import { ehMensagemDeEncerramento } from '../../../utils/encerramentoDoChat';
import { deveEmitirSinal } from '../../../utils/sinalDeDigitacao';
import { InsertDriveFileOutlined, ZoomIn } from '@material-ui/icons';
import React, { useCallback, useEffect, useState } from 'react';
import useChat from "../../../assets/socket/chat-socket";

import styles from './ChatMessages.module.css'
import { DoneAll, Done } from '@mui/icons-material';
import { Avatar, Grid, List, ListItem, Badge, Typography, Box, CardMedia, Dialog, DialogContent, IconButton } from '@mui/material';
import { useRef } from 'react';
import { Close } from '@material-ui/icons';
import CustomAudioPlayer from '../CustomAudioPlayer';
import { saudacaoGuardada } from '../../../utils/saudacaoDoChat';
import {
    SEGUNDOS_ATE_A_AVALIACAO,
    deveAgendarAAvaliacao,
    mostrarBotaoDeLer,
    rotuloDoBotaoDeAvaliar,
    textoDaTarja,
} from '../../../utils/avaliacaoDepoisDoEncerramento';
import { INTERVALO_DA_CONSULTA, estaNaFila, textoDaPosicao } from '../../../utils/posicaoNaFila';
import httpClient from '../../../assets/api/http-client';

/**
 * As regras do que acontece entre o encerramento e a avaliacao moram em
 * `utils/avaliacaoDepoisDoEncerramento`, com teste -- este componente monta
 * socket, upload e audio, e nao ha teste de componente neste repositorio.
 *
 * O que sobrou aqui e a FIACAO: o `setTimeout` que troca a tela, o relogio
 * que faz a contagem aparecer, e o botao que para os dois.
 */

const ChatMessages = ({ roomId, sendNewMessage, message, teclasDigitadas,
  sendingFile, setDisableChat, setNewMessage, showEndChatPrompt, setShowEndChatPrompt,
  // `status` ja era passado pelo pai e nao estava desestruturado: dentro do
  // componente o nome resolvia para o `window.status` global, que e uma string
  // vazia. Quem o lesse comparava com o objeto errado, sem erro nenhum.
  status,
  handleLogOut }) => {
  const {
    messages,
    sendMessage,
    readMessage,
    sendingMessageEvent,
    receiveMessage,
    sendFile,
    roomInfo,
    newRoom
  } = useChat(roomId); // Creates a websocket and manages messaging

  const [showSendingMessage, setShowSendingMessage] = useState(false);
  /*
   * A contagem ate a avaliacao, e o pedido de PARAR a contagem (ponto 3 da
   * Gisele). `null` enquanto a conversa esta viva.
   */
  const [segundosRestantes, setSegundosRestantes] = useState(null);
  /*
   * A posição na fila (ponto 8 da Gisele, 20/10/2026). `null` enquanto não
   * se sabe -- antes da primeira resposta, ou quando a conversa já tem
   * operador.
   */
  const [posicaoNaFila, setPosicaoNaFila] = useState(null);
  const [lendoAConversa, setLendoAConversa] = useState(false); // Message to be sent
  const [messagesLength, setMessagesLength] = useState(0);
  // A transicao para a avaliacao, agendada uma unica vez.
  const encerramentoAgendadoRef = useRef(null);

  // Se o componente sair antes da hora -- o cliente fecha a aba, a sala troca
  // --, o agendamento morre junto. Um `setTimeout` solto chamando `handleLogOut`
  // depois da desmontagem avisaria o React de atualizacao em componente morto.
  useEffect(() => () => {
    if (encerramentoAgendadoRef.current) clearTimeout(encerramentoAgendadoRef.current);
  }, []);
  const setDisableChatRef = useRef(setDisableChat)
  const messagesEndRef = useRef(null);
  // Ids de mensagens para as quais já pedimos "lida", para não reenviar a cada render.
  const readRequestedRef = useRef(new Set());
  const [openModal, setOpenModal] = useState(false);
  const [selectedPreview, setSelectedPreview] = useState(null); // URL do preview (imagem ou pdf)
  const [isPdfPreview, setIsPdfPreview] = useState(false);
  const [pdfLoadError, setPdfLoadError] = useState(false);

  // Zoom por scroll + arrastar (pan) na imagem ampliada, igual ao chat do
  // operador. Feito na mão com transform para não adicionar dependência.
  const ZOOM_MIN = 1;
  const ZOOM_MAX = 6;
  const [zoom, setZoom] = useState(1);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const [dragging, setDragging] = useState(false);
  const dragOriginRef = useRef(null);
  const clampZoom = (z) => Math.min(ZOOM_MAX, Math.max(ZOOM_MIN, z));

  // Zoom pela roda do mouse. O modal é tela cheia e o MUI trava o scroll do body
  // enquanto aberto, então não é preciso preventDefault (o onWheel do React basta
  // e evita problemas de timing ao anexar listener no portal do Dialog).
  const handleWheelZoom = useCallback((e) => {
    setZoom((prev) => {
      const next = clampZoom(prev * (e.deltaY < 0 ? 1.15 : 1 / 1.15));
      if (next === 1) setOffset({ x: 0, y: 0 });
      return next;
    });
  }, []);

  const handleImageMouseDown = (e) => {
    if (zoom <= 1) return;
    e.preventDefault();
    dragOriginRef.current = { x: e.clientX - offset.x, y: e.clientY - offset.y };
    setDragging(true);
  };

  const resetZoom = () => { setZoom(1); setOffset({ x: 0, y: 0 }); };

  useEffect(() => {
    if (!dragging) return undefined;
    const onMove = (e) => {
      const o = dragOriginRef.current;
      if (!o) return;
      setOffset({ x: e.clientX - o.x, y: e.clientY - o.y });
    };
    const onUp = () => { dragOriginRef.current = null; setDragging(false); };
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
    return () => {
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', onUp);
    };
  }, [dragging]);
  // Base de arquivos (mesma do Operator). Fallback para dev local.

  useEffect(() => {
    setShowEndChatPrompt(false);
    setDisableChatRef.current(false);
  }, [roomId, setShowEndChatPrompt]);

  useEffect(() => {
    if (localStorage.getItem('welcomeMessageSent') === "false") {
      /*
       * A saudação do DEPARTAMENTO escolhido, guardada na entrada (Gisele,
       * 19/10/2026). Antes era este texto, chumbado e igual para todo mundo,
       * enquanto a aba Mensagens já deixava escrever um por departamento.
       *
       * Departamento sem saudação configurada continua com a frase de sempre
       * (ela virou o padrão em `utils/saudacaoDoChat`): abrir a conversa muda
       * seria pior que a frase genérica.
       */
      sendMessage(saudacaoGuardada(), roomId, 4);

      setTimeout(() => {
        const userInputRaw = localStorage.getItem('userInput');

        let userInputData = null;
        if (userInputRaw) {
          try {
            userInputData = JSON.parse(userInputRaw);
          } catch (error) {
            console.error('Erro ao fazer parse do userInput:', error);
          }
        } else {
          console.log('userInput não encontrado no localStorage');
        }

        // Enviar dados do usuário (nome e code) via websocket
        if (userInputData) {
          newRoom({ name: userInputData.name, code: userInputData.code });
        } else {
          newRoom();
        }
      }, 100);

      localStorage.setItem('welcomeMessageSent', true)
    }

    if (!roomId || !messages || messages.length === 0) {
      setShowEndChatPrompt(false);
      return;
    }

    const lastMessage = messages[messages.length - 1];

    // A regra de reconhecer o encerramento mora em `utils/encerramentoDoChat`,
    // com teste: é ela que trava o chat, limpa a sessão e abre a avaliação, e
    // já errou em produção comparando com o NOME do operador da sala -- quando
    // outro operador encerrava, o texto não batia.
    if (ehMensagemDeEncerramento(lastMessage, roomId, roomInfo?.closing_message)) {
      setDisableChatRef.current(true);
      localStorage.clear();
      setShowEndChatPrompt(true);

      /*
       * A avaliação abre SOZINHA (ponto 5 da Gisele, 15/10/2026).
       *
       * Antes o cliente via "clique no botão para encerrar o chat e avaliá-lo"
       * e precisava clicar para só então chegar à avaliação. Muita gente
       * desistia ali, e o atendimento ficava sem nota -- regressão, porque
       * antes abria direto.
       *
       * ## Por que há um respiro antes
       *
       * A avaliação SUBSTITUI a conversa na tela. Trocar no mesmo instante em
       * que a mensagem de encerramento chega tiraria do cliente a chance de
       * lê-la, e ele cairia numa tela de notas sem entender o que aconteceu.
       * Os segundos abaixo são para ele ler a despedida -- não são um passo a
       * mais: ninguém precisa clicar em nada.
       *
       * ## Por que o ref
       *
       * Este efeito roda a cada mudança em `messages`. Sem a trava, cada
       * mensagem nova reagendaria a transição, e um `setTimeout` por
       * renderização ficaria pendurado.
       */
      /*
       * `lendoAConversa` para a contagem (ponto 3 da Gisele, 20/10/2026).
       *
       * Quem pediu para ler nao tem mais nada contando atras: a avaliacao
       * so abre quando ele clicar. Reagendar aqui seria tirar a conversa
       * da frente dele no meio da leitura, que e exatamente o que ela
       * relatou.
       */
      if (deveAgendarAAvaliacao(Boolean(encerramentoAgendadoRef.current), lendoAConversa)) {
        setSegundosRestantes(SEGUNDOS_ATE_A_AVALIACAO);
        encerramentoAgendadoRef.current = setTimeout(
          () => handleLogOut('byOperator'),
          SEGUNDOS_ATE_A_AVALIACAO * 1000
        );
      }
    } else {
      setShowEndChatPrompt(false);
    }

    if (Array.isArray(messages) && messages[messages.length - 1]) {
      const now = new Date();
      const lastMsgTime = new Date(messages[messages.length - 1].created_at);
      const diffMs = (lastMsgTime - now);
      const diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000);

      if (diffMins > 15) {
        // Aqui, em vez de modificar diretamente o array `messages`, 
        // você deve utilizar uma função para atualizar o estado.
        // Por exemplo: setMessages([...messages, novaMensagem])
        // Isso assegura que o estado seja atualizado de forma imutável.
      }
    }
    // eslint-disable-next-line
  }, [messages, roomInfo]);

  /*
   * O relogio que faz a contagem APARECER.
   *
   * Separado do `setTimeout` que troca a tela de proposito: quem decide a
   * hora da troca e o timeout, e este efeito so conta para o cliente ver.
   * Juntar os dois faria o numero na tela virar a fonte da verdade -- e uma
   * aba em segundo plano, onde o navegador estica os intervalos, atrasaria a
   * avaliacao junto.
   */
  useEffect(() => {
    if (segundosRestantes === null || lendoAConversa) return undefined;
    if (segundosRestantes <= 0) return undefined;

    const t = setTimeout(() => setSegundosRestantes((n) => (n === null ? null : n - 1)), 1000);

    return () => clearTimeout(t);
  }, [segundosRestantes, lendoAConversa]);

  /*
   * A POSIÇÃO NA FILA (ponto 8 da Gisele, 20/10/2026): "mostrar ao cliente do
   * Chat a posição dele na fila".
   *
   * Pergunta de tempos em tempos ENQUANTO estiver na fila, e para no instante
   * em que alguém pega a conversa. Quem decide "estou na fila?" e o que
   * escrever é `utils/posicaoNaFila`, com teste; aqui fica o relógio.
   *
   * Falha de rede ZERA a posição em vez de manter a última: a fila andou ou
   * não, não dá para saber, e repetir um número velho é pior do que não
   * mostrar nada -- o cliente ficaria olhando "3º" que não muda mais.
   */
  useEffect(() => {
    const operadorId = (() => {
      try { return JSON.parse(localStorage.getItem('roomInfo') || '{}')?.operatorId; } catch { return null; }
    })();

    if (!roomId || !estaNaFila(status, operadorId)) {
      setPosicaoNaFila(null);
      return undefined;
    }

    let cancelado = false;

    const perguntar = () => {
      httpClient.get(`/api/rooms/${roomId}/posicao-na-fila`)
        .then((r) => { if (!cancelado) setPosicaoNaFila(r?.data?.posicao ?? null); })
        .catch(() => { if (!cancelado) setPosicaoNaFila(null); });
    };

    perguntar();
    const t = setInterval(perguntar, INTERVALO_DA_CONSULTA);

    return () => { cancelado = true; clearInterval(t); };
  }, [roomId, status, messages]);

  /** "Ler a conversa": para a contagem e deixa a avaliacao para o cliente. */
  const pedirParaLer = () => {
    if (encerramentoAgendadoRef.current) {
      clearTimeout(encerramentoAgendadoRef.current);
      // Zerado, e nao so limpo: o efeito de cima olha este ref para nao
      // reagendar, e deixa-lo com o id morto faria a conversa nunca mais
      // agendar nada se o cliente mudasse de ideia.
      encerramentoAgendadoRef.current = null;
    }

    setSegundosRestantes(null);
    setLendoAConversa(true);
  };

  useEffect(() => {
    const send = async () => {
      if (sendNewMessage && message && message) {
        if (Array.isArray(messages) && messages.length !== 0) {
          if (messages[messages.length - 1].type === 3) {
            await sendMessage(message, roomId, 3);
          } else {
            await sendMessage(message, roomId, 0);
          }
          setNewMessage(""); // Limpa o campo de mensagem atual
        } else {
          await sendMessage(message, roomId, 0);
        }
      }

      /*
       * O SINAL DE "DIGITANDO" SAIU DAQUI (Gisele, 23/10/2026).
       *
       * Este efeito depende de `messages`, então ele roda a cada mensagem
       * nova da conversa. Enquanto o sinal era emitido aqui, bastava a flag
       * ficar ligada -- e ela ficava, porque era um interruptor invertido a
       * cada tecla -- para o operador ver "cliente está digitando" toda vez
       * que ELE MESMO mandava uma mensagem.
       *
       * Agora o sinal tem efeito próprio, logo abaixo, que observa a contagem
       * de teclas e mais nada.
       */
      if (sendingFile) {
        sendFile();
      }
    };

    send();
  }, [roomId, sendNewMessage, sendingFile, messages]);

  /*
   * "O cliente digitou" -- o único lugar que emite o sinal.
   *
   * Observa a CONTAGEM de teclas: ela só muda quando alguém digita, então
   * mensagem nova, troca de sala e re-render não disparam nada.
   *
   * O ref guarda o instante do último envio em vez de um estado porque ele não
   * desenha nada, e como estado cada tecla causaria um render a mais na tela
   * do cliente enquanto ele escreve.
   */
  const ultimoSinalEm = useRef(null);

  useEffect(() => {
    if (!teclasDigitadas) return;

    const agora = Date.now();

    if (!deveEmitirSinal(ultimoSinalEm.current, agora)) return;

    ultimoSinalEm.current = agora;
    sendingMessageEvent();
    // `sendingMessageEvent` vem do hook de socket e muda de identidade a cada
    // render; incluí-lo faria o efeito rodar sem ninguém ter digitado, que é
    // exatamente o defeito que este bloco conserta.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [teclasDigitadas]);

  useEffect(() => {
    if (receiveMessage) {
      setShowSendingMessage(true);
      setTimeout(() => {
        setShowSendingMessage(false);
      }, 1500);
    }
  }, [receiveMessage])

  useEffect(() => {
    if (!("Notification" in window)) {
      console.log("This browser does not support desktop notification");
    } else {
      Notification.requestPermission();
    }

    // Marca como lidas TODAS as mensagens não lidas do operador (type 1), e não só
    // a última — antes, ao enviar várias mensagens, apenas a última virava "lida".
    // Só marca quando a janela está ativa (visível e em foco), igual ao WhatsApp.
    const markIncomingAsRead = () => {
      if (!Array.isArray(messages)) return;
      const isActive = (typeof document === 'undefined' || !document.hidden) &&
        (typeof document === 'undefined' || typeof document.hasFocus !== 'function' || document.hasFocus());
      if (!isActive) return;
      messages.forEach((m) => {
        if (m && m.type === 1 && !m.read_at && !readRequestedRef.current.has(m.id)) {
          readRequestedRef.current.add(m.id);
          readMessage(m.id);
        }
      });
    };

    // Se a janela já estiver em foco quando a mensagem chegar, marca na hora.
    markIncomingAsRead();

    window.addEventListener('focus', markIncomingAsRead);
    document.addEventListener('visibilitychange', markIncomingAsRead);

    return () => {
      window.removeEventListener('focus', markIncomingAsRead);
      document.removeEventListener('visibilitychange', markIncomingAsRead);
    };
  });

  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }

    if ("Notification" in window && Notification.permission !== "denied") {
      if (Notification.permission === "granted") {
        if (Array.isArray(messages) && messages.length && !messages[messages.length - 1].read_at && messages[messages.length - 1].type === 1) {
          new Notification(JSON.parse(localStorage.getItem('roomInfo')).name, { body: messages[messages.length - 1].message });
        }
      } else {
        Notification.requestPermission().then((permission) => {
          if (permission === "granted") {
            new Notification("Você tem novas mensagens!", { body: Array.isArray(messages) && messages.length ? messages[messages.length - 1].message : "Nova mensagem" });
          }
        });
      }
    }

    if (Array.isArray(messages) && messagesLength !== messages.length) {
      setMessagesLength(messages.length);
    }
    // eslint-disable-next-line
  }, [messages.length]);

  const SafeHtmlMessage = ({ htmlContent }) => (
    <Grid sx={{ maring: '0 8px' }} dangerouslySetInnerHTML={{ __html: sanitizeChatMessage(htmlContent) }} />
  );

  const handleClickOpen = (url, type = 'image') => {
    setSelectedPreview(url);
    setIsPdfPreview(type === 'pdf');
    setPdfLoadError(false);
    setZoom(1);
    setOffset({ x: 0, y: 0 });
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedPreview(null);
    setPdfLoadError(false);
    setZoom(1);
    setOffset({ x: 0, y: 0 });
  };

  const isImageFile = (archive) => {
    if (!archive) return false;
    const extension = archive.split('.').pop().toLowerCase();
    return ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension);
  };

  const isPdfFile = (archive) => {
    if (!archive) return false;
    const extension = archive.split('.').pop().toLowerCase();
    return extension === 'pdf' || archive.toLowerCase().includes('.pdf');
  };

  const handleMessage = message => {
    if (!message.archive) {
      if (message.type === 4)
        return (
          <Grid className={styles.automatic}>
            <Grid>
              <Typography variant='h6' className={styles.text} >Mensagem automática</Typography>
            </Grid>
            <Grid className={styles.message} ><SafeHtmlMessage htmlContent={message.message} /></Grid>
          </Grid>
        )
      else
        return <SafeHtmlMessage htmlContent={message.message} />
    } else {
      var archive = message.archive.split('/');
      const fileUrl = chatAttachmentUrl(roomId, message.archive);

      // Se for uma imagem, mostra preview clicável
      if (isImageFile(message.archive)) {
        // Legenda: mostra o texto enviado junto da imagem (estilo WhatsApp). Não
        // exibe se estiver vazio nem se for apenas o nome do arquivo de imagem
        // (mensagens antigas guardavam o filename no campo message).
        const caption = (message.message || '').trim();
        const isFilename = /\.(jpe?g|png|gif|webp)$/i.test(caption);
        return (
          <Box sx={{ maxWidth: '100%', width: '20rem' }}>
            <Box className={styles['avatar-container']} sx={{ width: '100%' }}>
              <CardMedia
                component="img"
                image={fileUrl}
                alt={caption || 'imagem'}
                sx={{ borderRadius: '10px', maxHeight: '200px', objectFit: 'cover', cursor: 'pointer', height: '5rem' }}
                onClick={() => handleClickOpen(fileUrl, 'image')}
              />
              <Grid className={styles['avatar-overlay']} onClick={() => handleClickOpen(fileUrl, 'image')}>
                <ZoomIn />
              </Grid>
            </Box>
            {caption && !isFilename && (
              <Typography sx={{ mt: 0.5, fontSize: '0.9rem', color: 'var(--text-primary)', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                {caption}
              </Typography>
            )}
          </Box>
        );
      }

      // Se for PDF, mostra bloco clicável para preview em modal (iframe)
      if (isPdfFile(message.archive)) {
        return (
          <Grid sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <InsertDriveFileOutlined />
            <a
              href={fileUrl}
              onClick={(e) => { e.preventDefault(); handleClickOpen(fileUrl, 'pdf'); }}
              className={styles.fileLink}
              hrefLang="pt-BR"
            >
              {message.message || archive[1]}
            </a>
          </Grid>
        );
      }

      // Se for áudio (ogg/opus/mp3/wav), usar player customizado
      const isAudio = /\.(ogg|opus|mp3|wav)$/i.test(message.archive);
      if (isAudio) {
        return <CustomAudioPlayer archive={message.archive} roomId={roomId} />;
      }

      // Para outros tipos de arquivo, mostra link de download
      return (
        <Grid>
          <InsertDriveFileOutlined />
          <a
            href={fileUrl}
            download={archive[1]}
            className={styles.fileLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            {message.message}
          </a>
        </Grid>
      );
    }
  };

  const handleInfo = message => {
    var time = message.created_at.split("T");
    time = time[1].split(":");

    if (message.type) {
      if (message.read_at) {
        return (
          <Grid className={styles.messageTimeOperator}>
            {time[0]}:{time[1]}
            {/* <DoneAll style={{ fontSize: '14px', color: '#63ACE5', marginLeft: '1%' }} /> */}
          </Grid>
        )
      } else {
        return (
          <Grid className={styles.messageTimeOperator}>
            {time[0]}:{time[1]}
            {/* <Done style={{ fontSize: '14px', marginLeft: '1%' }} /> */}
          </Grid>
        )
      }
    } else {
      if (message.read_at) {
        // Lida: duplo tique AZUL (igual ao operador/WhatsApp), para diferenciar
        // claramente de "enviada" — antes usava cinza (var(--text-muted)) e ficava
        // praticamente indistinguível do tique único de enviada.
        return (
          <Grid className={styles.messageTimeClient}>
            <DoneAll style={{ fontSize: '14px', color: '#63ACE5', marginRight: '1%' }} />
            {time[0]}:{time[1]}
          </Grid>
        )
      } else if (message.meta?.ack === 2) {
        // Entregue: duplo tique CINZA (o operador recebeu, mas ainda não leu).
        return (
          <Grid className={styles.messageTimeClient}>
            <DoneAll style={{ fontSize: '14px', marginRight: '1%' }} />
            {time[0]}:{time[1]}
          </Grid>
        )
      } else {
        // Enviada: tique único.
        return <Grid className={styles.messageTimeClient}>{<Done style={{ fontSize: '14px', marginRight: '1%' }} />} {time[0]}:{time[1]}</Grid>;
      }
    }
  };

  return (
    <Grid>
      <p className='chat-message-notification'>Olá! seja bem vindo,
        um dos nossos especialistas já irá lhe atender!</p>


      <List className={styles.messagesList}>
        {Array.isArray(messages) ? messages.map((message, i) => (
          message.type !== 5 ? (
            <ListItem className={styles.messagesList}
              key={i} ref={i === (Array.isArray(messages) ? messages.length - 1 : 0) ? messagesEndRef : null}>
              {!message.type
                ? <></>
                : message.type !== 4 ?
                  <Grid container className={styles.avatarWithName}>
                    {message.user && (
                      <Badge
                        className={styles.operatorBadge}
                        anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'right',
                        }}
                      >
                        <Avatar className={styles.operatorImg}
                          src={message.user.picture}
                          alt='Foto de perfil'
                        />
                        <Typography className={styles.operatorName}>{message.user.name}</Typography>
                      </Badge>
                    )}
                  </Grid>

                  : null
              }
              <Grid container flexDirection={'column'} className="message-container" xs={12} >
                <Grid xs={6} className={`${message.type === 3 ? null : message.type === 4 ? null :
                  message.type ? styles.messageItem + ' ' + styles.receivedMessage : styles.messageItem + ' ' + styles.myMessage
                  }`}>
                  <Grid item>{handleMessage(message)}</Grid>
                </Grid>
                <Grid item>{handleInfo(message)}</Grid>
              </Grid>
            </ListItem>
          )
            : null
        )) : null}
        {/* Display "Sending file" message when uploading a file */}
        {sendingFile ?
          <li key={99999}>
            <div className="message-container">
              <div className={`message-item my-message`}>
                <InsertDriveFileOutlined /> Enviando arquivo...
              </div>
              <p style={{ textAlign: 'right', color: 'var(--text-muted)', fontSize: '10px', marginRight: '2%' }}></p>
            </div>
          </li>
          :
          ''
        }
      </List>
      {/*
        * A fila, enquanto ninguém pegou a conversa (ponto 8 da Gisele).
        *
        * Some sozinha: o efeito acima para de perguntar e zera a posição no
        * instante em que um operador assume, e sem posição não há tarja.
        */}
      {textoDaPosicao(posicaoNaFila) && (
        <Grid className={styles.messageClose} data-testid="posicao-na-fila">
          {textoDaPosicao(posicaoNaFila)}
        </Grid>
      )}

      {
        showEndChatPrompt && (
          /*
           * O texto mudou junto com o comportamento (Gisele, 15/10/2026).
           *
           * Ele dizia "clique no botão para encerrar o chat e avaliá-lo", e
           * era esse clique que fazia muita gente desistir antes de avaliar.
           * Agora a avaliação abre sozinha, e o texto conta isso em vez de
           * pedir uma ação.
           *
           * O botão fica como atalho para quem não quer esperar -- e como
           * rede: se a transição automática falhar, o cliente não fica preso
           * numa conversa travada sem saída.
           */
          <Grid className={styles.messageClose}>
            {textoDaTarja(lendoAConversa, segundosRestantes)}
            <button onClick={() => handleLogOut('byOperator')} className={styles.buttonLogoutClose} variant='contained'>
              {rotuloDoBotaoDeAvaliar(lendoAConversa)}
            </button>
            {/*
              * O outro lado do ponto 3: parar a contagem para ler o que
              * aconteceu. Some depois de clicado porque ja nao ha o que
              * parar -- um botao que nao faz nada e pior que nenhum.
              */}
            {mostrarBotaoDeLer(lendoAConversa) && (
              <button onClick={pedirParaLer} className={styles.buttonLogoutClose} variant='contained'>
                Ler a conversa
              </button>
            )}
          </Grid>
        )
      }

      <div style={
        showSendingMessage ?
          {
            display: 'inline',
            textAlign: 'center',
            color: 'var(--text-muted)',
            fontSize: '0.8125rem',
            fontWeight: 500,
            position: 'fixed',
            bottom: '7%',
            left: '50%',
            transform: 'translateX(-50%)',
            padding: '0.35rem 0.75rem',
            background: 'var(--surface-elevated)',
            border: '1px solid var(--border)',
            borderRadius: '9999px',
            boxShadow: 'var(--shadow-sm)',
          }
          :
          { display: 'none' }
      }
      >Operador está digitando…</div>

      {/* Modal para visualização de imagens */}
      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        maxWidth="lg"
        fullWidth
        sx={{
          '& .MuiDialog-paper': {
            backgroundColor: 'rgba(0, 0, 0, 0.55)',
            boxShadow: 'none',
            borderRadius: '12px',
            margin: 2,
          },
        }}
      >
        <DialogContent sx={{ position: 'relative', padding: 0, height: '80vh', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <IconButton
            onClick={handleCloseModal}
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
              backgroundColor: 'rgba(0, 0, 0, 0.6)',
              color: 'white',
              zIndex: 2,
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.85)',
              },
            }}
          >
            <Close />
          </IconButton>
          {!isPdfPreview && zoom > 1 && (
            <Box sx={{ position: 'absolute', bottom: 12, left: '50%', transform: 'translateX(-50%)', zIndex: 2, display: 'flex', alignItems: 'center', gap: 1, backgroundColor: 'rgba(0,0,0,0.6)', borderRadius: 999, px: 1.2, py: 0.4 }}>
              <Typography sx={{ color: 'white', fontSize: '0.78rem' }}>{Math.round(zoom * 100)}%</Typography>
              <Typography
                onClick={resetZoom}
                sx={{ color: 'white', fontSize: '0.78rem', cursor: 'pointer', textDecoration: 'underline', '&:hover': { color: '#cfe3ff' } }}
              >
                Resetar
              </Typography>
            </Box>
          )}
          {selectedPreview && (
            isPdfPreview ? (
              pdfLoadError ? (
                <Box sx={{ p: 2, textAlign: 'center', backgroundColor: 'white', borderRadius: '8px' }}>
                  <Typography variant="h6" gutterBottom>Não foi possível carregar o PDF</Typography>
                  <Typography variant="body2" color="text.secondary" gutterBottom>
                    O arquivo pode estar protegido ou com restrições de acesso. Tente abrir em nova aba.
                  </Typography>
                  <a href={selectedPreview} target="_blank" rel="noopener noreferrer" className={styles.fileLink}>
                    Abrir PDF em nova aba
                  </a>
                </Box>
              ) : (
                <iframe
                  src={selectedPreview}
                  title="Pré-visualização do PDF"
                  style={{ width: '90vw', height: '90vh', border: 'none', borderRadius: '8px', backgroundColor: 'white' }}
                  onError={() => setPdfLoadError(true)}
                />
              )
            ) : (
              <Box
                onWheel={handleWheelZoom}
                onMouseDown={handleImageMouseDown}
                sx={{
                  width: '100%',
                  height: '100%',
                  overflow: 'hidden',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: zoom > 1 ? (dragging ? 'grabbing' : 'grab') : 'zoom-in',
                }}
              >
                <img
                  src={selectedPreview}
                  alt="Visualização"
                  draggable={false}
                  style={{
                    maxWidth: '92vw',
                    maxHeight: '88vh',
                    objectFit: 'contain',
                    transform: `translate(${offset.x}px, ${offset.y}px) scale(${zoom})`,
                    transformOrigin: 'center center',
                    transition: dragging ? 'none' : 'transform 0.08s ease-out',
                    userSelect: 'none',
                  }}
                />
                {zoom <= 1 && (
                  <Typography sx={{ position: 'absolute', bottom: 12, left: '50%', transform: 'translateX(-50%)', color: 'white', backgroundColor: 'rgba(0,0,0,0.55)', px: 1.5, py: 0.4, borderRadius: 999, fontSize: '0.8rem', pointerEvents: 'none' }}>
                    Role o scroll sobre a imagem para ampliar
                  </Typography>
                )}
              </Box>
            )
          )}
        </DialogContent>
      </Dialog>
    </Grid>
  );
};

export default ChatMessages;